import { render, staticRenderFns } from "./PassengerDashboard.vue?vue&type=template&id=3abc741f&"
import script from "./PassengerDashboard.vue?vue&type=script&lang=js&"
export * from "./PassengerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports